export default __webpack_public_path__ + "static/media/gc.5a7d6a01.gif";